import httpService, { HttpResponse } from '../../../core/services/HttpService';

interface AvailabilityRange {
  start: number;
  end: number;
}

interface DayAvailability {
  weekday: number;
  all_day: boolean;
  not_at_all: boolean;
  ranges: AvailabilityRange[];
}

interface AvailabilityApiResponse {
  weekday: number;
  all_day?: boolean;
  not_at_all?: boolean;
  ranges?: AvailabilityRange[];
}

interface BulkSavePayload {
  employee: number;
  availabilities: DayAvailability[];
}

class AvailabilitiesService {
  async fetchAvailabilities(empId: number): Promise<DayAvailability[]> {
    const response: HttpResponse<AvailabilityApiResponse[]> = await httpService.get(`/api/availabilities/?employee=${empId}`);
    const data = response.data || [];
    return data.map(item => ({
      weekday: item.weekday,
      all_day: item.all_day || false,
      not_at_all: item.not_at_all || false,
      ranges: Array.isArray(item.ranges) ? [...item.ranges] : []
    }));
  }

  async saveAvailabilities(employeeId: number, payload: BulkSavePayload): Promise<void> {
    await httpService.post(`/api/admin/employees/${employeeId}/availabilities`, payload);
  }
}

export default new AvailabilitiesService(); 